import { Drawer } from "@mui/material";
import { WorkItemDraftsGrid } from "../grid";
import { DrawerHeader } from "@sagecentral/core-ui";
import { WorkItemPermissionsProvider } from "components/work-items";

type WorkItemDraftGridProps = {
    opener: boolean,
    onClose: any
};

const WorkItemDraftsDrawer = (props: WorkItemDraftGridProps) => {
    const { opener, onClose } = props;
    return (
        <WorkItemPermissionsProvider>
            <Drawer
                anchor={'right'}
                onClose={onClose}
                open={opener}
                PaperProps={{
                    sx: {
                        width: '70%',
                        backgroundColor: "rgba(255, 255, 255, 1)"
                    }
                }}
                sx={{ zIndex: 1300, '& .MuiBox-root': {width: 'auto', fontFamily:'Open Sans', backgroundColor: '#F7F7F7'} }}>
                <DrawerHeader title='Work Item drafts' onClose={() => onClose()} />
                <WorkItemDraftsGrid/>
            </Drawer>
        </WorkItemPermissionsProvider>
    );
};

export default WorkItemDraftsDrawer;